import IconItem from './icon_item';

export default class Image extends IconItem {
  constructor() {
    super('image');
  }
}
